<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <div class="control">
            <h1 class="title is-5">
              {{employeeDetail.last_name}} {{employeeDetail.name}} {{employeeDetail.patronymic}}
            </h1>
          </div>
        </div>
      </div>
      <div class="columns mt-15">
        <div class="column is-2">
          <div class="image w100p">
            <img v-if="employeeDetail.thumb" :src="employeeDetail.thumb" alt="">
            <img v-else src="../../assets/user.svg" alt="">
          </div>
          <div v-if="isPersonalProfile" class="button w100p mt-15" @click="edit">
            <b-icon icon="pencil" size="is-small" class="icon"></b-icon>
            <span>{{ $t('interface.edit') }}</span>
          </div>
        </div>
        <div class="column is-6">
          <table class="account-detail">
            <tr>
              <td><strong>{{ $t('employees.position') }}</strong></td>
              <td>
                <template v-if="employeeDetail.position__name">
                  {{ employeeDetail.position__name }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.department') }}</strong></td>
              <td>
                <template v-if="employeeDetail.department__name">
                  {{ employeeDetail.department__name }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.birthday') }}</strong></td>
              <td>
                <template v-if="employeeDetail.birthday">
                  {{ employeeDetail.birthday | localedDateWithYear }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.mobilePhone') }}</strong></td>
              <td>
                <template v-if="employeeDetail.mobile_phone">
                  {{ employeeDetail.mobile_phone }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.workPhone') }}</strong></td>
              <td>
                <template v-if="employeeDetail.work_phone">
                  {{ employeeDetail.work_phone }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.hiredDate') }}</strong></td>
              <td>
                <template v-if="employeeDetail.hired_date">
                  {{ employeeDetail.hired_date | localedDateWithYear }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr v-if="employeeDetail.is_dismissed">
              <td><strong>{{ $t('employees.dismissalDate') }}</strong></td>
              <td>{{ employeeDetail.dismissal_date | localedDateWithYear }}</td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.category') }}</strong></td>
              <td>
                <template v-if="employeeDetail.position_type__name">
                  {{ employeeDetail.position_type__name }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('employees.workplace') }}</strong></td>
              <td>
                <template v-if="employeeDetail.workplace_office">
                  {{ employeeDetail.workplace_office }}, {{ employeeDetail.workplace_level }} {{ $t('employeeDetail.floor') }},
                  {{ employeeDetail.workplace_cabinet_number }} {{ $t('employeeDetail.cabinet') }}
                </template>
                <template v-else>
                  <span class="has-text-grey-light">&ndash;</span>
                </template>
              </td>
            </tr>
          </table>
          <div>
            <p class="has-text-weight-bold mt-15 mb-5">{{ $t('employees.about') }}</p>
            <p v-if="employeeDetail.bio">{{employeeDetail.bio}}</p>
            <template v-else>
              <span class="has-text-grey-light">&ndash;</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {}
    },
    methods: {
      edit() {
        this.$router.push({
          name: 'editEmployeeData',
          params: {employeeId: this.$route.params.employeeId}
        })
      }
    },
    mounted() {
      this.$store.dispatch('Employees/read', this.$route.params.employeeId)
    },
    computed: {
      ...mapState('Employees', ['employeeDetail']),
      ...mapState('Account', ['account']),
      isPersonalProfile() {
        return parseInt(this.$route.params.employeeId) === this.account.employee.id
      },
      breadcrumbs() {
        return [
          {name: 'employeeDetail'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .account-detail {
    tr {
      td {
        padding-bottom: 10px;
      }
      td:last-child {
        padding-left: 40px
      }
    }
  }
</style>